import { forwardRef, type Ref, type SVGProps } from "react";
const IconPiggyBankOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 12h-1.02A10.7 10.7 0 0 0 24 8.26V3.5a.5.5 0 0 0-.49-.5h-.01c-1.86.03-5.75.27-7.55 2.79a.49.49 0 0 1-.4.21h-.71a10.9 10.9 0 0 0-10.19 6.95A.9.9 0 0 1 4 12v-.01A1 1 0 1 0 2 12a2.95 2.95 0 0 0 2.14 2.89A10 10 0 0 0 4 16.46a10.5 10.5 0 0 0 4 8.28V28a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2.57a10 10 0 0 0 1.56-1.17 1.02 1.02 0 0 1 .67-.26H28a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m0 10h-2.77a3 3 0 0 0-2.01.78 9 9 0 0 1-1.27.95l-.95.59V27h-2.05a2.5 2.5 0 0 0-2.45-2h-2a2.5 2.5 0 0 0-2.45 2H10v-3.23l-.76-.6A8.46 8.46 0 0 1 6 16.47 8.7 8.7 0 0 1 14.84 8h.71a2.5 2.5 0 0 0 2.03-1.05c.52-.74 1.71-1.6 4.42-1.87v4.15l.76.6a8.6 8.6 0 0 1 2.41 3.03l.54 1.14H28z" />
    <path d="M22 14a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
    <path d="M16 11h-3a2.92 2.92 0 0 0-3 2.83V14a1 1 0 0 0 2 0 .91.91 0 0 1 .82-1 1 1 0 0 1 .18 0h3a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconPiggyBankOutlineSVG);
ForwardRef.displayName = "IconPiggyBankOutline";
export { ForwardRef as IconPiggyBankOutline };
